// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/route_style.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { RouteStyleService } from "./route_style_pb";

/**
 * ListRouteStyles returns the active styles offered for a city (global set
 * plus any city overrides), or the global set when city_id is empty.
 *
 * @generated from rpc travplaces.v1.RouteStyleService.ListRouteStyles
 */
export const listRouteStyles = RouteStyleService.method.listRouteStyles;
